import React, {useCallback} from 'react';
import {connect} from 'react-redux';

import {FilterControlsV2} from '@ey/canvascoreservices/FiltersControls';

import {labels} from '../../../../../../util/utils';
import Utility from '../../../../../../util/utilityfunctions';

import {setMessageLogFilter, clearMessageLogFilters} from '../../../../../../actions/ContactDB';

const MessageLogFilterControls = ({
	actions,
	filterData,
	userPreferences,
	filterConfiguration,
	state,
	dispatch,
	numberOfChips,
	_syncQueryString
}) => {
	const handleOnClearFilters = () => {
		actions.clearMessageLogFilters();
		actions.setContacts(null);
	};

	const handleOnDisableFilter = useCallback(
		(filter, value) => {
			actions.setMessageLogFilter(filter.name, value);
			actions.setMessages({name: filter.name, value: value});
		},
		[actions]
	);

	const handleSetState = useCallback(
		(callback) => {
			dispatch({
				type: 'state/set',
				value: {
					filters: callback(state.filters)
				}
			});
		},
		[state.filters, dispatch]
	);

	return (
		<FilterControlsV2
			_syncQueryString={_syncQueryString}
			filterKey={filterConfiguration.key}
			state={state.filters}
			setState={handleSetState}
			count={numberOfChips}
			dropdownPlacement="bottom-right"
			store={filterData}
			actions={actions}
			userPreferences={userPreferences}
			clearHover={labels.clearHoverText}
			clearAll={labels.contactClearAll}
			more={labels.contactShowMoreFilters}
			onClearFilters={handleOnClearFilters}
			onDisableFilter={handleOnDisableFilter}
			theme={Utility.getMotifTheme()}
		/>
	);
};

const mapState = (state, ownProps) => {
	return {
		filterData: state.filterData[ownProps.filterConfiguration.key],
		messageLogFilters: state.MessageLogFilters,
		userPreferences: state.userPreferences
	};
};

const mapDispatch = (dispatch) => {
	return {
		actions: {
			clearMessageLogFilters: (initialState) => dispatch(clearMessageLogFilters(initialState)),
			setMessageLogFilter: (filterItemName, value) => dispatch(setMessageLogFilter(filterItemName, value))
		}
	};
};

export default connect(mapState, mapDispatch)(MessageLogFilterControls);
